import BaseAPI from '@/apis/base/baseApi';

class EmployeeAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'employee';
}

export default new EmployeeAPI();
